export const currencyList = [
  { id: 1, name: "£", type: "GBP" },
  // { id: 2, name: "$", type: "USD" },
  // { id: 3, name: "€", type: "EUR" },
];
